<main class="container">
  <div class="builder-layout">

    <!-- LEFT COLUMN -->
    <div class="left-column">

      <!-- Start Here -->
      <div class="block">
        <div class="section-label">Start Here</div>

        <label class="field-label">What do you need to produce?</label>
        <div class="field-desc">
          Choose the type of communications work you're doing.
        </div>

        <div class="selector-row">
          <select
            class="form-control builder-dropdown"
            [(ngModel)]="selectedPromptName"
            (change)="onCategoryChange()">
            <option value="">— Select a prompt type —</option>
            @for (group of groupedPrompts; track group.label) {
              <optgroup [label]="group.label">
                @for (item of group.items; track item.name) {
                  <option [value]="item.name">
                    {{ item.name }}
                  </option>
                }
              </optgroup>
            }
          </select>

          <button
            class="star-btn"
            (click)="toggleStar()"
            [class.active]="isCurrentPromptStarred">
            {{ isCurrentPromptStarred ? '★' : '☆' }}
          </button>
        </div>
      </div>

      <!-- DESCRIPTION -->
      @if (descVisible && currentPrompt) {
        <div class="block" style="background-color:#e6f3ff;">
          <div class="prompt-desc-name">
            {{ currentCrumb }}
          </div>
          <div class="prompt-desc-text">
            {{ currentPrompt.description }}
          </div>
          <div class="prompt-bring">
            {{ currentPrompt.bring }}
          </div>
        </div>
      }

      <!-- SOURCE -->
      @if (sourceVisible) {
        <div class="block">
          <div class="source-header-row">
            <span class="source-title">What are you working with?</span>
            <span class="source-optional">(optional — but it matters)</span>
          </div>

          <div class="source-desc">
            Paste in anything relevant — a brief, backgrounder, email chain, meeting notes, or bullet points.
          </div>

          <!--“What are you working with?” text field-->
          <textarea
            class="form-control"
            rows="5"
            [(ngModel)]="sourceMaterial"
            (ngModelChange)="onSourceInput()"
            maxlength="1000">
          </textarea>

          <div class="source-impact">
            The more context you provide, the more specific your output will be.
          </div>
        </div>
      }

      <!-- MAIN FIELDS -->
      <div class="block">
        <div class="section-label">Tell us about your situation</div>

        @if (!currentPrompt) {
          <div class="empty-state">
            <p>Select a prompt type to get started.</p>
          </div>
        }

        
@if (currentPrompt) {
  @let p = currentPrompt;

          @for (field of p.fields; track field.id) {

            <div class="field-group">

              <label class="field-label">
                {{ field.label }}
                @if (field.required) {
                  <span class="req">*</span>
                }
              </label>

              @if (field.desc) {
                <div class="field-desc">
                  {{ field.desc }}
                </div>
              }

              <!-- SELECT -->
              @if (field.type === 'select') {
                <select
                  class="form-control builder-dropdown"
                  [ngModel]="fieldValues[field.id]"
                  (ngModelChange)="onMainFieldChange(field.id, $event)">
              
                  <option value="">— Select —</option>
              
                  @for (o of field.options; track o) {
                    <option [value]="o">{{ o }}</option>
                  }
              
                </select>
              }

              <!-- TEXT -->
                <!--“Timeline” section -->
             @if (field.type === 'text' && (field.label === 'Timeline' || field.label === 'Campaign Timeline')) {
                <input
                  type="date"
                  class="form-control"
                  [ngModel]="fieldValues[field.id]"
                  (ngModelChange)="onMainFieldChange(field.id, $event)" />
              }

                <!--“Topic / Initiative” & “Primary Objective” sections -->
              @if (field.type === 'text' && field.label !== 'Timeline' && field.label !== 'Campaign Timeline') {
                <input
                  class="form-control"
                  [ngModel]="fieldValues[field.id]"
                  (ngModelChange)="onMainFieldChange(field.id, $event)"
                  maxlength="500" />
              }


              <!-- TEXTAREA -->
              @if (field.type === 'textarea') {
                <textarea
                  class="form-control"
                  rows="4"
                  [ngModel]="fieldValues[field.id]"
                  (ngModelChange)="onMainFieldChange(field.id, $event)"
                  maxlength="1000">
                </textarea>
              }

            </div>

          }
        }
      </div>

      <!-- ADD-ONS -->
      @for (addOnName of activeAddOns; track addOnName) {
        <div class="block">

          @if (getAddOnPrompt(addOnName); as p) {

            <div class="addon-header">
              <span>{{ p.name }}</span>
              <button class="addon-remove" (click)="removeAddOn(addOnName)">
                X Remove
              </button>
            </div>

            @for (field of getAddOnFields(addOnName); track field.id) {
              <div class="field-group">

                <label>{{ field.label }}</label>

                @if (field.type === 'select') {
                  <select
                    class="form-control builder-dropdown"
                    [ngModel]="addOnFieldValues[addOnName]?.[field.id]"
                    (ngModelChange)="onAddOnFieldChange(addOnName, field.id, $event)">
                
                    <option value="">— Select —</option>
                
                    @for (o of field.options; track o) {
                      <option [value]="o">{{ o }}</option>
                    }
                
                  </select>
                }

                <!-- “If your project continues…” section -->
                @if (field.type === 'text') {
                  <input
                    class="form-control"
                    [ngModel]="addOnFieldValues[addOnName]?.[field.id]"
                    (ngModelChange)="onAddOnFieldChange(addOnName, field.id, $event)"
                    maxlength="500" />
                }

              </div>
            }

          }

        </div>
      }

    </div>

    <!-- RIGHT COLUMN -->
    <div class="right-column">
      <div class="sticky-wrapper">

        @if (currentPrompt) {
          <div class="block">
            <div class="output-sublabel">
              <div class="section-label">Your prompt</div>
              Copy this into
              <a
                class="copilot-inline-link"
                href="https://m365.cloud.microsoft/chat?"
                target="_blank"
                rel="noopener noreferrer">Microsoft Copilot</a>.
              The more context you provide, the more specific your result.
            </div>

            @if (progressVisible) {
              <div class="progress-container">       
                <!-- ✅ Progress bar -->
                <div class="progress-bar-wrapper">
                  <div 
                    class="progress-bar-fill"
                    [style.width.%]="progressPercent">
                  </div>
                </div>
                <!-- ✅ Label -->
                <div class="progress-text">
                  {{ progressLabel }}
                </div>
          
              </div>
            }

            @if (statusVisible) {            
              <div class="status-box">
                {{ statusText }}
              </div>
            }

            <pre class="output-el">{{ outputText }}</pre>
            <div class="output-footer">
              <span class="char-count">{{ charCountText }}</span>
              <div class="output-actions">
                <button
                type="button"
                class="btn"
                [ngClass]="copyButtonDisabled ? 'btn-secondary' : 'btn-primary'"
                (click)="copyPrompt()"
                [disabled]="copyButtonDisabled">
                {{ copyButtonText }}
              </button>
              </div>
            </div>
          </div>
        } @else {
          <div class="block">
            <div class="output-sublabel">
              <div class="section-label">Your prompt</div>
              {{ outputSublabel }}
            </div>

            <pre class="output-el">No prompt selected.</pre>
            <div class="output-footer empty-output-footer">
              <span></span>
              <div class="output-actions">
                <button
                  type="button"
                  class="btn btn-secondary"
                  disabled>
                  Copy Prompt
                </button>
              </div>
            </div>
          </div>
        }

        <div class="block feedback-block">
          <div class="section-label">Have feedback or a prompt idea?</div>
          <div class="feedback-content">
            Help us improve the Prompt Builder by sharing suggestions, enhancement requests, or new prompt ideas.
            <a
              href="https://go.chevron.com/CA-PromptBuilder-Feedback"
              target="_blank"
              rel="noopener noreferrer">Click here to submit your feedback</a>
            through Microsoft Forms.
          </div>
        </div>

        <!-- SAVE -->
        @if (false && saveVisible) {

          <div class="block">
            <!-- 1. Title line -->
            <div class="section-label">Save This Configuration</div>
          
            <!-- 2. Row layout -->
            <div class="save-row">
              <input
                [(ngModel)]="saveNameInput"
                class="form-control"
                placeholder="Name this configuration and save"
              />
          
              <div class="action-buttons">               
                <button
                  type="button"
                  class="btn btn-primary"
                  (click)="saveConfig()">
                  Save
                </button>
                <button
                  type="button"
                  class="btn btn-secondary"
                  (click)="shareConfig()">
                  Share
                </button>
              </div>
            </div>
          </div>
          
        }

        <!-- SAVED CONFIG -->
        @if (false && savedVisible) {
          <div class="block">
            
<div class="section-label" (click)="toggleSavedList()">
  {{ showSavedList ? '−' : '+' }} List of Saved Configurations
</div>

            @if (savedListOpen) {
              <div class="saved-list">
                @for (s of savedConfigs; track s.saveName; let i = $index) {
                  <div class="saved-row" (click)="loadConfig(i)">
                    <span class="config-name">
                    {{ i + 1 }}. &nbsp; {{ s.saveName }}
                    </span>
              
                    <button
                      type="button"
                      class="btn btn-secondary btn-sm delete-btn"
                      (click)="deleteConfig(i); $event.stopPropagation()">
                      ×
                    </button>
                  </div>
                }              
              </div>              
            }

          </div>
        }

      </div>
    </div>

  </div>
</main>


